export default {
    changeInfoSendMessage: '/reports/send-message/change-infos/',//{info} (INIT, MEDIA, USER, PROPERTY, MESSAGE) 
    SendMessage: '/reports/send-message/send',
    PreviewMessage: '/reports/send-message/preview',
    CheckStatusSendMessage: '/reports/send-message/status/',
    GetHtmlContent: '/reports/send-message/content/',
    LargeMailing: '/reports/mass-mailing/send',
    getInvalidPersonEmails: '/reports/mass-mailing/check-email-persons/',
    checkInvalidPersonEmails: '/reports/mass-mailing/persons/check-email-persons',
    checkInvalidDemandEmails: '/reports/mass-mailing/demands/check-email-persons ',
    UploadPictureMailing: 'reports/upload-picture-mailing',
    getMessageTemplates: '/reports/send-message/get-documents/{messageId}',
    getPropertyDocument: '/reports/send-message/get-documents-property/{propertyId}',
    getPersonDocument: '/reports/send-message/get-documents-person/{personId}',

    getPrintTemplateTempletesLookup: '/reports/templates',
    getPrintTemplateDocumentsLookup: '/reports/extra-documents/:propertyids',
    sendPrintTemplate: '/reports/print-message/send',
    CheckStatusPrintTemplate: '/reports/print-message/status/', 

    getDesignedMessageTemplates: '/common/newmessages/get-tokens',
    
    // Large Email
    getBeePluginToken: '/reports/mass-mailing/bee-plugin-token',
    getAllTemplate: '/omni-template/templates',
    insertTemplate: '/omni-template',
    updateTemplate: '/omni-template/:id',
    deleteTemplate: '/omni-template/:id',
    getBeePluginConfig: '/reports/mass-mailing/bee-plugin-config',

    // SMS
    getSmsTemplate: '/reports/message/smstemplate',
    renderSmsTemplate: '/reports/message/rendersmstemplate',
    checkInternationalPhones: '/phone/is-international',
    updateSmsTemplate: '/reports/message/updatesmstemplate',
    insertSmsTemplate: '/reports/message/insertSmsTemplate',
    getMessageTypes: '/common/lookup-data/MessageTypes',

    // Message
    getTemplateMessage: '/reports/messages',
    checkESignEmailTemplateExist: '/reports/check-e-sign-email-template-exists'
}